import React from 'react';
import { useParams } from 'react-router-dom';
import { WorkflowRunner } from '../../../../components';

import './Workflow.css';

const Workflow = props => {
    const { tkt_instance_id } = props;
    const { workflow_id }     = useParams();

    return (
        <div className="Workflow">
            <div className="wrapper">
                <div className="container border rounded p-3 bg-white">
                    {workflow_id && tkt_instance_id && (
                        <WorkflowRunner
                            workflow_id={ workflow_id }
                            tkt_instance_id={ tkt_instance_id }
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Workflow;
